<template>
  <SettingsPagePanel>
    <TeamManagementForm
      :team="team"
      :is-loading="isLoading"
      :is-submitting="isSubmitting"
    />
  </SettingsPagePanel>
</template>

<script setup lang="ts">
import SettingsPagePanel from '../SettingsPagePanel.vue'
import { useRoute } from 'vue-router'
import { useTeamDetail } from './composables/useTeamDetail'
import TeamManagementForm from '@/components/organisms/TeamManagementForm/TeamManagementForm.vue'

const route = useRoute('teamManagementSettingDetail')
const teamGUID = route.params.teamManagementSettingId

const { team, isLoading, isSubmitting } = useTeamDetail(teamGUID)
</script>
